import { Star, Users, Briefcase, Globe, Award, Zap } from 'lucide-react';

const benefits = [
  {
    icon: Star,
    title: 'Экспертная оценка',
    description: 'Твою работу оценят профессионалы индустрии и дадут персональные рекомендации.',
  },
  {
    icon: Users,
    title: 'Команда единомышленников',
    description: 'Найди друзей и будущих коллег, с которыми можно создавать крутые проекты.',
  },
  {
    icon: Briefcase,
    title: 'Стажировки и гранты',
    description: 'Лучшие участники получат предложения о стажировках и финансовую поддержку проектов.',
  },
  {
    icon: Globe,
    title: 'Выход на всероссийский уровень',
    description: 'Победители представят Югру на федеральных конкурсах и выставках.',
  },
  {
    icon: Award,
    title: 'Портфолио и сертификаты',
    description: 'Пополни своё портфолио реальным проектом и получи сертификат от организаторов.',
  },
  {
    icon: Zap,
    title: 'Быстрый старт в карьере',
    description: 'Получи навыки, востребованные в геймдеве, 3D-графике и геймдизайне.',
  },
];

export default function BenefitsSection() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-primary-50 to-accent-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            ОЧКИ это:
          </h2>
          
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="card hover:shadow-xl transition-shadow bg-white/80 backdrop-blur-sm"
            >
              <div className="flex items-center space-x-4 mb-4">
                <div className="p-3 bg-primary-100 rounded-lg">
                  <benefit.icon className="h-6 w-6 text-primary-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900">{benefit.title}</h3>
              </div>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>
          <p className="mt-4 text-lg text-gray-600 text-center">
            Чемпионат — это не просто соревнование, а трамплин для твоего профессионального роста.
          </p>
        <div className="text-center mt-12">
          <div className="inline-flex items-center justify-center p-1 bg-gradient-to-r from-primary-500 to-accent-500 rounded-full">
            <div className="bg-white px-8 py-4 rounded-full">
              <p className="text-gray-900 font-semibold">
                Регистрация открыта до <span className="text-primary-600">30 октября 2026</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}